// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/promotional-banner-item/promotional-banner-item.component.scss
// module id = 472
// module chunks = 0